import {addEventAction, editEventAction} from "./actions";

export default (state={} , action) => {
    switch (action.type) {
        case addEventAction.resultAction :
        case editEventAction.resultAction :
            return action.payload.data ;
        default :
            return state;
    }
}